import {  } from '../actions/siteActions'

const initialState = {
    // Cloudflare Turnstile site key for newfangle.press — used by both the
    // Contact and Submissions forms.
    turnstileSiteKey: '0x4AAAAAAEbvH9_3uGEUHqa4'
}

export default function alert(state = initialState, action) {
    switch (action.type) {
        default:
            return state
    }
}
